import { Component, Input } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';

@Component({
standalone: false,
  selector: 'app-toolbar-additional-info',
  styleUrls: ['./toolbar-additional-info.component.scss'],
  templateUrl: './toolbar-additional-info.component.html',
})
export class ToolbarAdditionalInfoComponent {
  @Input() public message: string;
  @Input() public icon: string;
  @Input() public class: ToolbarClass;
  @Input() public routerLink: string;

  public showTooltips: boolean;

  constructor(private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.Medium,
    ]).subscribe((breakpointState: BreakpointState) => {
      this.showTooltips = breakpointState.matches;
    });
  }
}

type ToolbarClass = 'status-ok' | 'status-pending';
